import { Inject, Injectable } from '@angular/core';
import { AUTHENTICATION_SERVICE, AuthenticationService } from '@/app/platform/platform-core/user/services/types';
import { USER_ACTIVATOR, UserActivator } from '@/app/platform/platform-core/user/activators/types';
import { PlatformInstanceListener } from '@/app/platform/platform-core/user/listeners/platform-instance-listener';
import { currentTab } from '@/app/current-tab';

@Injectable({
  providedIn: 'root'
})
export class UserInitializer {
  constructor(
    @Inject(AUTHENTICATION_SERVICE)
    private readonly authService: AuthenticationService,
    @Inject(USER_ACTIVATOR)
    private readonly userActivator: UserActivator,
    private readonly platformInstanceListener: PlatformInstanceListener
  ) {}

  async init() {
    await this.tryLoadSavedUser();
    await this.platformInstanceListener.init();
  }

  private async tryLoadSavedUser() {
    const result = await this.authService.loadSavedAuthentication();
    result
      .ifSuccess(r => {
        this.userActivator.activateOnDesktop(r);
      })
      .ifError(e => {
        currentTab.clearAuth();
      });
  }
}
